import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useAdminMode } from '../context/AdminModeContext';
import PortfolioDashboard from '../components/PortfolioDashboard';

export default function Dashboard() {
  const { isSuperAdmin, user } = useAuth();
  const { isPlatformMode, isOrganizationMode } = useAdminMode();

  // Brokers see Portfolio Dashboard (scoped to their orgs via API)
  if (user?.role === 'broker') {
    return <PortfolioDashboard />;
  }

  // Super Admin in Platform Mode - show Portfolio Dashboard
  if (isSuperAdmin() && isPlatformMode) {
    return <PortfolioDashboard />;
  }

  // Super Admin in Organization Mode - redirect to Org IQ
  if (isSuperAdmin() && isOrganizationMode) {
    return <Navigate to="/org-iq" replace />;
  }

  // Non-Super Admin users (Org Admins, regular users) - redirect to Org IQ
  // Org IQ is their primary view
  return <Navigate to="/org-iq" replace />;
}
